import { HttpVerb } from './http-verb.enum';
// export type RequestDataType<V extends HttpVerb> = _RequestDataType<V> | null
export class Route {
    method;
    static make(path, method = HttpVerb.GET) {
        return new Route(path, method);
    }
    path;
    constructor(_path, method) {
        this.method = method;
        if (typeof _path === 'string') {
            this.path = () => _path;
        }
        else {
            this.path = _path;
        }
    }
    /*
     * Soooo, yes, we're tricking TypeScript. It complains that the generics
     * "RouteReturnType" and "Data" are unused, even though they're used very
     * effectively for type hinting.
     */
    dummyRequestReturnType() {
        this.dummyRequestDataType();
        return;
    }
    dummyRequestDataType() {
        this.dummyRequestReturnType();
        return;
    }
}
//# sourceMappingURL=route.js.map